import z from "zod";
import { ModifierGroupIdScheme, ModifierIdScheme } from "./ids";
import { CatalogOrigin } from "./enums/CatalogOrigin";

export const ModifierGroupDBScheme = z.object({
  id: ModifierGroupIdScheme,
  name: z.string(),
  modifiers: z.array(ModifierIdScheme),
  minAmount: z.number().optional().nullable(),
  maxAmount: z.number().optional().nullable(),
  alwaysPrompt: z.boolean().optional().nullable(),
  origin: z.enum(CatalogOrigin).optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const RestGetModifierGroup = ModifierGroupDBScheme;

export const RestCreateModifierGroup = ModifierGroupDBScheme.omit({
  id: true,
  updatedAt: true,
  createdAt: true,
});

export const RestUpdateModifierGroup = ModifierGroupDBScheme.omit({
  id: true,
  updatedAt: true,
  createdAt: true,
}).partial();

export type DBModifierGroup = z.infer<typeof ModifierGroupDBScheme>;
export type RestModifierGroup = z.infer<typeof RestGetModifierGroup>;
export type RestCreateModifierGroup = z.infer<typeof RestCreateModifierGroup>;
export type RestUpdateModifierGroup = z.infer<typeof RestUpdateModifierGroup>;
